import { render } from "./CustomerInvoices.vue?vue&type=template&id=0a981a54&scoped=true"
import script from "./CustomerInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerInvoices.vue?vue&type=script&lang=js"

import "./CustomerInvoices.vue?vue&type=style&index=0&id=0a981a54&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a981a54"]])

export default __exports__